import styled from "styled-components"

export const FaqStyles = styled.section`
  margin-bottom: calc(var(--gap) / 2.5);

  .question {
    min-height: calc(var(--gap) * 1.8);
    width: 100%;
    background-color: var(--color-panel);
    border: 1px solid var(--color-line);
    border-radius: 14px;
    color: var(--color-paper);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 16px 22px;
    font-family: var(--font-display);
    font-weight: 700;
    font-size: var(--h5);
    text-align: left;
    cursor: pointer;
    transition: border-color 0.3s var(--ease-power),
      background-color 0.3s var(--ease-power);

    &:hover {
      border-color: var(--color-gold-500);
    }

    .trigger {
      display: inline-flex;
      height: 34px;
      width: 34px;
      flex: none;
      position: relative;
      font-size: 30px;
      justify-content: center;
      align-items: center;
      color: var(--color-gold-500);
      transform-origin: center;
      transition: transform 0.5s var(--ease-power);
    }
  }

  .answer {
    overflow: hidden;
    padding: calc(var(--gap) / 2) 22px;

    p {
      margin: 0;
      font-size: var(--p);
      color: var(--color-ash);
    }
  }

  &.faq-open {
    .question {
      border-color: var(--color-line);
    }

    .trigger {
      transform: rotate(-180deg);
    }
  }
`
